import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// import { styled } from '@mui/system';
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import {getAaffSuppServ } from "../../../services";
import { formatoFechasEs } from "../../../functions/funciones";
import { Link } from "react-router-dom";
import { CircularProgress } from '@mui/material';

export default function ControlledAccordions(props) {
  const { t } = useTranslation(['properties', 'common']);
  const [expanded, setExpanded] = useState(false);
  const [AAFF, setAAFF] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getData()
  }, [props.proveedor])

  const getData = async () => {

    if (Object.keys(props.proveedor).length > 0) {
      const resA = await getAaffSuppServ(props.proveedor.nif);
      if(Object.keys(props.aaff).length > 0){
        resA.forEach(a=> {
          if(a.id === props.aaff.id){
            setAAFF([a])
          }
        })
      }else{
        setAAFF(resA)
      }
    }
    setIsLoading(false)
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="root" style={{ margin: "15", position: 'relative', overflow: 'scroll', maxHeight: 750 }}>
      {isLoading ? <CircularProgress style={{ width: '40px', height: '40px', color: '#92004D', position: 'absolute', top: '50%', left: '50%', margin: '50px 0px' }} /> : 
        AAFF?.length === 0 ? <p style={{ padding: '20px'}}>{t('noCommunities')}</p> :
        AAFF?.map((e, i) => (
          <Accordion
            key={i}
            style={{ margin: "0" }}
            expanded={expanded === "panel" + i}
            onChange={handleChange("panel" + i)}
          >
            <AccordionSummary
              style={{ background: "rgb(251 251 251)" }}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography style={{ flex: "auto" }} className="heading">
                {e.razonSocial}
              </Typography>
            </AccordionSummary>
            <AccordionDetails key={i}>
              <Typography>
                {e.properties?.length === 0 ? (
                  <span key={0} style={{ margin: "10px 0" }}>
                    {t('noProperties')}
                  </span>
                ) : (
                  e.properties?.map((f, j) => (
                    <>
                      <span key={j} style={{ margin: "10px 0" }}>
                        <Link to={`/aaff/${e.nif}/comunidades/${f.nif}`} target="_blank">{f.razonSocial}</Link> <br />
                        <small>
                          <b>{t('documents.riskAssessment')}:</b>{" "}
                          {f.docsProps.find( dr => dr?.nombre === "identificacion de riesgos")?.docsReads[0]?.updatedAt !== undefined ?
                            formatoFechasEs(f.docsProps.find( dr => dr?.nombre === "identificacion de riesgos")?.docsReads[0]?.updatedAt)
                            : t('common:time.never')
                          }
                          {/* {f.docsRead.find( dr => dr.nombre === "identificacion de riesgos" )?.r_doc_reads?.updatedAt !==undefined ?
                            formatoFechasEs(f.docsRead.find( dr => dr.nombre === "identificacion de riesgos" )?.r_doc_reads?.updatedAt)
                          : t('common:time.never')
                          } */}
                        </small>
                        <br />
                        <small>
                          <b>{t('documents.emergencyPlan')}: </b>
                          {
                            f.docsProps.find( dr => dr?.nombre === "plan de emergencia")?.docsReads[0]?.updatedAt !== undefined ?
                            formatoFechasEs(f.docsProps.find( dr => dr?.nombre === "plan de emergencia")?.docsReads[0]?.updatedAt)
                            : t('common:time.never')
                          }
                          {/* {f.docsRead.find( dr => dr.nombre === "plan de emergencia" )?.r_doc_reads?.updatedAt !==undefined ?
                            formatoFechasEs(f.docsRead.find( dr => dr.nombre === "plan de emergencia" )?.r_doc_reads?.updatedAt)
                          : t('common:time.never')
                          } */}
                        </small>
                        <br />
                        <small>
                          <b>{t('common:form.service')}: </b>
                          {f?.servicio.map((s, i) => {
                            return (
                              <span key={s?.nombre}>
                                {s?.nombre}
                                {i < f.servicio.length - 1 && ', '}
                              </span>
                            )
                          })}
                        </small>
                      </span>
                      <br />
                      <br />
                    </>
                  ))
                )
                }
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))
      }
      <style jsx="true">{`
        .root {
          width: "100%";
        }
        .heading: {
          font-size: 0.9375rem;
          flex-basis: "33.33%";
          flex-shrink: 0;
        }
        .secondaryheading: {
          fontsize: 0.9375rem;
          color: theme.palette.text.secondary;
        }
      `}</style>
    </div>
  );
}
